var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12.6404V20H7V4h2v.957c1.0205.0182 2.3851.1447 3.9836.543 1.2611.3142 2.2564.3545 3.0166.275 1.3967-.1462 2-.6968 2-.6968V13s-1.5694 1.84-5.0166.3627c-.7037-.3017-1.3696-.492-1.9836-.6039a8.3796 8.3796 0 0 0-.9561-.1184 7.9425 7.9425 0 0 0-1.0439 0zm7.0002-.7592c-.3775.0893-1.0909.1308-2.2287-.3568-1.8271-.7831-3.4757-.9559-4.7715-.8875V6.9573c.884.0182 2.0836.1304 3.5001.4834 1.371.3416 2.533.419 3.5001.3426v4.0979z",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.3f18d387f1b81cce772092d882f0ad93.svg";
export { ForwardRef as ReactComponent };